(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["also-available-on-block"] && !Shopify.designMode) return;
  try {
    
function initializeAlsoAvailableSlider() {
  const $slider = $('.also-available-slider');
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    cssEase: 'ease',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeAlsoAvailableSlider);
document.addEventListener('shopify:section:load', initializeAlsoAvailableSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers-product-lists"] && !Shopify.designMode) return;
  try {
    
function initializeBestSellerSlider() {
  const $slider = $('.best-seller-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    arrows: false, // arrows hidden
    dots: true,    // dot navigation
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeBestSellerSlider);
document.addEventListener('shopify:section:load', initializeBestSellerSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts-lists"] && !Shopify.designMode) return;
  try {
    
function initHemBlogSlider() {
  const $slider = $('.hem-blog-slider');
  const itemCount = $slider.children().length;

  if (itemCount > 1) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true,
      arrows: false,
      adaptiveHeight: false,
      infinite: true,
      speed: 500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
}

document.addEventListener('DOMContentLoaded', initHemBlogSlider);
document.addEventListener('shopify:section:load', initHemBlogSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-slider"] && !Shopify.designMode) return;
  try {
    
function initializeCollectionSlider() {
  const $slider = $('.collection-slider-section .collection-slider');

  $slider.slick({
    arrows: true,
    dots: false,
    infinite: false,
    swipeToSlide: true,
    touchMove: true,
    slidesToShow: 7, 
    slidesToScroll: 1,
    prevArrow: $('.collection-slider-prev'),
    nextArrow: $('.collection-slider-next'),
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3.3
        }
      }
    ]
  });
}
document.addEventListener('DOMContentLoaded', initializeCollectionSlider);
document.addEventListener('shopify:section:load', initializeCollectionSlider);
document.addEventListener('shopify:block:select', initializeCollectionSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["combo-product-lists"] && !Shopify.designMode) return;
  try {
    
function initializeComboProductsSlider() {
  const $slider = $('.combo-products-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    arrows: false, // arrows hidden
    dots: true,    // dot navigation
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeComboProductsSlider);
document.addEventListener('shopify:section:load', initializeComboProductsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["company-stat"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const counters = document.querySelectorAll('.stat-count');

  const startCounter = (counter) => {
    const fullText = counter.getAttribute('data-target'); // e.g. "100+"
    const match = fullText.match(/^([\d\.]+)([^\d]*)$/); // Separate number and suffix

    if (!match) return;

    const number = parseFloat(match[1]);
    const suffix = match[2];
    let count = 0;
    const step = Math.ceil(number / 100);
    
    const updateCount = () => {
      if (count < number) {
        count += step;
        counter.innerText = count + suffix;
        setTimeout(updateCount, 20);
      } else {
        counter.innerText = number + suffix;
      }
    };

    updateCount();
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        startCounter(counter);
        observer.unobserve(counter); // Only trigger once
      }
    });
  }, {
    threshold: 0.6 // 60% visible
  });

  counters.forEach(counter => {
    observer.observe(counter);
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
function initializeTestimonialsSlider() {
  const $slider = $('.customer-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeTestimonialsSlider);
document.addEventListener('shopify:section:load', initializeTestimonialsSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-slideshow"] && !Shopify.designMode) return;
  try {
    
function initializeHeroSlider() {
  const $slider = $('.hero-banner-slider .slick-slider');

  // Unbind any previous slider
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  // Bind 'init' event BEFORE slick() call
  $slider.on('init', function () {
    document.querySelector('.static-hero-slide')?.remove();
    $slider.addClass('visible'); // triggers CSS fade-in
  });

  // Initialize slick
  $slider.slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true, 
    cssEase: 'linear',
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  // Optional: in case layout needs refresh
  $slider.slick('setPosition');
}

document.addEventListener('DOMContentLoaded', initializeHeroSlider);
document.addEventListener('shopify:section:load', initializeHeroSlider);
document.addEventListener('shopify:block:select', initializeHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    const priceElements = document.querySelectorAll('.singleboxprice');
    priceElements.forEach(function(el) {
      el.textContent = el.textContent.replace(/MRP\s*/i, '');
    }); 
  }); 
var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-videos-lists"] && !Shopify.designMode) return;
  try {
    
function initializeProductVideosSlider() {
  const $slider = $('.product-videos-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  $slider.slick({
    dots: true, 
    arrows: false,
    infinite: false,
    swipeToSlide: true,
    touchMove: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeProductVideosSlider);
document.addEventListener('shopify:section:load', initializeProductVideosSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-collection-slider"] && !Shopify.designMode) return;
  try {
    
function initializeProductVideoTestimonialSlider() {
  const $slider = $('.product-video-testimonial-slider');

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    swipeToSlide: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3
        }
      }
    ]
  });
}

document.addEventListener('DOMContentLoaded', initializeProductVideoTestimonialSlider);
document.addEventListener('shopify:section:load', initializeProductVideoTestimonialSlider);

  } catch(e) { console.error(e); }
})();
})();
